import React from "react";
import ProjectStatusTemplate from "../components/project-status/ProjectTemplate";
import { getSEOData } from "../utils/seo";

function ProjectStatus() {
  const seoData = getSEOData("project-status");
  return <ProjectStatusTemplate seoData={seoData} />;
}

export default ProjectStatus;
